import { z } from 'zod';

// @plachtova: there is no easy way to get the schema from json keys, so we must do it manually
// when adding another language, do not forget to add it here and in '~/plugins/i18n/isoCodes.json'
export const LocaleSchema = z.enum(['cs', 'en'] as const);
export type Locale = z.infer<typeof LocaleSchema>;
